/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CrosshairsIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Crosshairs',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path d="M18 15.8a2.2 2.2 0 1 0 2.2 2.2 2.2 2.2 0 0 0-2.2-2.2Z" />
    <path
      d="M18 2a16 16 0 1 0 16 16A16 16 0 0 0 18 2Zm2 29.552V24h-4v7.552A13.7 13.7 0 0 1 4.448 20H12v-4H4.448A13.7 13.7 0 0 1 16 4.448V12h4V4.448A13.7 13.7 0 0 1 31.552 16H24v4h7.552A13.7 13.7 0 0 1 20 31.552Z"
    />
  </svg>`;
};
